import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BreadcrumbsService } from '../../core/breadcrumbs.service';
import { FormGroup, FormControl } from '@angular/forms';
import { ScrollService } from '../../core/scroll.service';
import { AuthService, IUserInfo, F_ERR_MSG__INVALID_LOGIN } from '../../api/auth.service';
import { LangService } from '../../core/lang.service';
import { Subscription } from 'rxjs';

interface ILoginFormErrors {
  isBlank?:boolean,
  isInvalid?: boolean,
}
@Component({
  selector: 'login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit, OnDestroy {

  public breadcrumb = [];
  public isFormValidated:boolean;
  public isFormSent:boolean;
  public isFormFailed:boolean;
  public formGroup = new FormGroup({
    emailAddress: new FormControl(),
    password: new FormControl(),
  })
  private formSubs:Subscription[] = [];

  constructor(
    private lang: LangService,
    private auth: AuthService,

    private breadcrumbsService: BreadcrumbsService,
    private router:Router,
    private route:ActivatedRoute,
    private scrollService:ScrollService,
    private langService:LangService,
  ) {

  }
  
  ngOnInit() {
    const onFormValueChange = (r) => this.isFormSent = false;
    this.formSubs = this.formSubs.concat([
      (<FormControl>this.formGroup.controls.emailAddress).valueChanges.subscribe(onFormValueChange),
      (<FormControl>this.formGroup.controls.password).valueChanges.subscribe(onFormValueChange)
    ])
  }

  ngOnDestroy() {
    this.formSubs.forEach(sub => sub.unsubscribe() );
  }

  validateForm(){
    // TO DO: a lot of this validation makes even more sense to have in the registration area, abstract these functions
    
    this.isFormValidated = false; 
    let hasAnyErrors = false;
    const email = <FormControl>this.formGroup.controls.emailAddress;
    const password = <FormControl>this.formGroup.controls.password;
    let emailErrors:ILoginFormErrors = {}
    let passwordErrors:ILoginFormErrors = {}
    if (!email.value){
      emailErrors.isBlank = true;
      hasAnyErrors = true;
    }
    else{
      const str = <string>email.value;
      const isMissingAtSign = str.indexOf('@') === -1;
      const isTooShort = str.length < 4;
      if (isMissingAtSign || isTooShort){
        emailErrors.isInvalid = true;
        hasAnyErrors = true;
      }
    }

    if (!password.value){
      passwordErrors.isBlank = true;
      hasAnyErrors = true;
    }
    else{
      const str = <string>password.value;
      if (str.length < 6){ // should be 8, but I need to type in my password
        passwordErrors.isInvalid = true;
        hasAnyErrors = true;
      }
    }
    email.setErrors(emailErrors);
    password.setErrors(passwordErrors);
    this.formGroup.markAsUntouched();
    if (hasAnyErrors){
      return; 
    }
    // const controls = [email, password];
    this.formGroup.disable();
    this.isFormValidated = true; 
  }

  onApiError(e:{message:string}){
    const email = <FormControl>this.formGroup.controls.emailAddress;
    const password = <FormControl>this.formGroup.controls.password;
    this.formGroup.enable();
    this.isFormValidated = false;
    if (e.message == F_ERR_MSG__INVALID_LOGIN){
      this.isFormFailed = true;
    }
  }

  isInputBlank(control:FormControl){
    return control.untouched && control.hasError('isBlank');
  }

  isInputInvalid(control:FormControl){
    return control.untouched && control.hasError('isInvalid');
  }

  submitForm(){
    this.isFormFailed = false;
    this.validateForm();
    if (this.isFormValidated){
      this.isFormSent = true;
      const email = this.formGroup.controls.emailAddress.value;
      const password = this.formGroup.controls.password.value;
      this.auth
        .login( email, password )
        .catch(e => this.onApiError(e))
    }
  }

}
